"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function getSelector() {
  var keys = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    keys[_i] = arguments[_i];
  }

  return (keys || []).join('-');
}

exports.getSelector = getSelector;